import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  FormControl,
  Input,
  FormLabel,
  useToast,
  FormHelperText,
  VStack,
  Select as ChakraSelect,
} from "@chakra-ui/react";
import Select from "react-select";
import ExpertB2BDataService from "../../services/ExpertB2B";
import React, { useEffect, useState } from "react";
import { Spinner } from "@chakra-ui/react";
import { DateTime } from "luxon";

export const MonthlyB2BExpertDownloadBillingSheet = ({
  isOpen,
  onClose,
}: any) => {
  const toast = useToast();
  const [downloadLoader, setdownloadLoader] = useState<any>(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [status, setStatus] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const initialRef = React.useRef(null);

  const generateMonthYearArray = () => {
    try {
      const startDate = DateTime.fromObject({
        month: 1, // January
        year: 2025,
      });
      const endDate = DateTime.now();
      let currentDate = startDate;
      const monthYearArray = [];
      let i = 0;

      while (currentDate <= endDate) {
        monthYearArray.push({
          month: currentDate.toFormat("MM"), // returns 01, 02, 03... for months
          year: currentDate.year,
          text: `${currentDate.toFormat("MMMM")}-${currentDate.year}`, // January-2025
          index: i.toString(),
        });
        currentDate = currentDate.plus({ months: 1 });
        i++;
      }

      return monthYearArray;
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  const selectedMonth = generateMonthYearArray().find(
    (el) => el.index === selectedValue
  );

  const handleSubmit = () => {
    setdownloadLoader(true);
    if (selectedMonth) {
      setdownloadLoader(true);
      ExpertB2BDataService.downloadB2BExpertsBillingSheet(
        selectedMonth.month,
        selectedMonth.year.toString(),
        paymentStatus,
        status,
      )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${selectedMonth?.month}-${selectedMonth?.year}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          toast({
            position: "top",
            title: "Billing Sheet Downloaded Successfully",
            description: "The billing sheet has been downloaded successfully",
            status: "success",
            duration: 1500,
            isClosable: true,
          });
        })
        .catch((error) => {
          console.error("Error downloading payments:", error.message);
          toast({
            position: "top",
            title: "Billing Sheet Download Failed",
            description:
              "There was an error downloading the billing sheet. Please try again later.",
            status: "error",
            duration: 1500,
            isClosable: true,
          });
        })
        .finally(() => {
          setdownloadLoader(false);
          setSelectedValue("");
          onClose();
        });
    }
  };

  const handleSelecion = (value: any) => {
    setSelectedValue(value);
  };

  return (
    <>
      <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Filters</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl mt={5}>
              <VStack spacing={5}>
                <ChakraSelect
                  value={selectedValue}
                  onChange={(e) => handleSelecion(e.target.value)}
                >
                  <option value="">Select Month</option>
                  {generateMonthYearArray().map((el) => (
                    <option value={el.index}>{el.text}</option>
                  ))}
                </ChakraSelect>
                <ChakraSelect
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value="">Select Status</option>
                  <option value="tbc">To Be Confirmed</option>
                  <option value="confirmed">Confirmed</option>
                </ChakraSelect>
                <ChakraSelect
                  value={paymentStatus}
                  onChange={(e) => setPaymentStatus(e.target.value)}
                >
                  <option value="">Select Payment Status</option>
                  <option value="approved">Approved</option>
                  <option value="hold">Hold</option>
                  <option value="rejected">Rejected</option>
                </ChakraSelect>
              </VStack>
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button
              bgColor="#327171"
              color={"white"}
              mr={3}
              onClick={handleSubmit}
            >
              {downloadLoader ? <Spinner size="sm" /> : "Download"}
            </Button>
            <Button bgColor="red" color={"white"} onClick={onClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
